import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { CountryModel } from '../../shared/models/country.model';

@Injectable({
    providedIn: 'root'
})

export class CountryService {

    constructor(private translate: TranslateService, private httpClient: HttpClient) { }

    carregarListaDePaises(): Observable<Array<CountryModel>> {
        return new Observable(observable => {
            this.httpClient.get('./assets/countries/countries.json')
                .subscribe(
                    (res: Array<any>) => {
                        const language = this.translate.currentLang == null ? this.translate.defaultLang : this.translate.currentLang;
                        const countrys = new Array<CountryModel>();

                        let countryModelo: CountryModel;

                        for (const country of res) {
                            if (language === 'pt') {
                                countryModelo = new CountryModel();
                                countryModelo.CODIGO = country.name;
                                countryModelo.TITULO = country.translations.br != null ? country.translations.br : country.translations.es;
                            } else if (language === 'en') {
                                countryModelo = new CountryModel();
                                countryModelo.CODIGO = country.name;
                                countryModelo.TITULO = country.name;
                            } else if (language === 'es') {
                                countryModelo = new CountryModel();
                                countryModelo.CODIGO = country.name;
                                countryModelo.TITULO = country.translations.es != null ? country.translations.es : country.translations.br;
                            }
                            countrys.push(countryModelo);
                        }

                        countrys.sort((a, b) => {
                            a.TITULO = a.TITULO.charAt(0).toUpperCase() + a.TITULO.slice(1);
                            b.TITULO = b.TITULO.charAt(0).toUpperCase() + b.TITULO.slice(1);

                            const comparison = a.TITULO.localeCompare(b.TITULO);
                            if (comparison === 0) {
                                return a.TITULO.localeCompare(b.TITULO);
                            }
                            return comparison;
                        });

                        observable.next(countrys);
                        observable.complete();
                    },

                    err => {
                        console.log(err.message);
                    }
                );
        });
    }

}
